const puntoVenta = {
  createPuntoVenta: 'punto-venta',
  readPuntoVenta: 'punto-venta/{{uuid_punto_venta}}',
  readPuntosVenta: 'punto-venta/{{uuid_academia}}/{{activo}}',
  updatePuntoVenta: 'punto-venta/{{uuid_punto_venta}}',
  updatePuntoVentaEstado: 'punto-venta/{{uuid_academia}}/{{uuid_punto_venta}}/{{nuevo_estado}}'
}

export default puntoVenta
